import React, { useState, useEffect } from 'react';
import {
  Box,
  FormControl,
  Avatar,
  Button,
  Typography,
  TextField,
  Autocomplete,
  CircularProgress,
  Container,
  Paper,
  Grid,
  Card,
  CardContent,
  Chip,
  Stack,
  Fade,
  Grow,
  useTheme,
  alpha,
  IconButton,
  Tooltip,
  Collapse
} from '@mui/material';
import {
  Person,
  Assignment,
  Refresh,
  CheckCircle,
  Close,
  Favorite,
  Timeline,
  Analytics,
  ExpandMore,
  ExpandLess,
  FolderOpen
} from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import api from '../api/axiosConfig';
import { getMediaBaseUrl } from '../utils/mediaUrl';
import { useSearchParams } from 'react-router-dom';

import ListboxComponent from '../components/ListboxComponent ';

// ---> IMPORTACIÓN DE SUBCOMPONENTES
import CreateInforme from './ContenuFiche/CreateInforme';
import CreateIntel from './ContenuFiche/CreateIntel';
import CreateMedia from './ContenuFiche/CreateMedia';
import CreateTecnica from './ContenuFiche/CreateTecnica';
import CreateMedical from './ContenuFiche/CreateMedical';
import CreateMedidas from './ContenuFiche/CreateMedidas';
import CreateDocuments from './ContenuFiche/CreateDocuments';

const PlayerCardCreator = () => {
  const theme = useTheme();
  const { t } = useTranslation();
  
  // ========================
  // ESTADOS PRINCIPALES
  // ========================
  const [players, setPlayers] = useState([]);
  const [selectedPlayer, setSelectedPlayer] = useState(null);
  const [cardType, setCardType] = useState('');
  const [fecha, setFecha] = useState('');
  const [evento, setEvento] = useState('');
  const [fuente, setFuente] = useState('');
  const [equipo, setEquipo] = useState('');
  const [detalles, setDetalles] = useState('');
  const [userId, setUserId] = useState(null);
  const [eventos, setEventos] = useState([]);
  const [visualizacion, setVisualizacion] = useState('');
  const [titre, setTitre] = useState('');
  const [videoUrl, setVideoUrl] = useState('');
  const [teams, setTeams] = useState([]);
  const [existingEquipos, setExistingEquipos] = useState([]);
  const [showPlayerSelection, setShowPlayerSelection] = useState(true);

  // Nuevos estados para informe
  const [nivel, setNivel] = useState('');
  const [projection, setProjection] = useState('');
  const [verdict, setVerdict] = useState('');
  const [mediaFile, setMediaFile] = useState(null);
  const [fitEstilo, setFitEstilo] = useState(null);
  const [fitFisico, setFitFisico] = useState(null);
  const [fitActitud, setFitActitud] = useState(null);
  const [fitMejora, setFitMejora] = useState(null);
  const [fitContexto, setFitContexto] = useState(null);
  const [statsUrl, setStatsUrl] = useState('');
  const [defensiveVersatility, setDefensiveVersatility] = useState(null);

  // Nuevo: Controlar si el formulario ha cambiado (para avisar si se navega)
  const [isDirty, setIsDirty] = useState(false);

  // Para bloquear el doble submit
  const [isSubmitting, setIsSubmitting] = useState(false);

  const mediaUrl = getMediaBaseUrl();
  const section = process.env.REACT_APP_SECTION;
  const backendUrl = process.env.REACT_APP_BACKEND_URL;

  // ===========================
  // ESTADOS FICHA TÉCNICA
  // ===========================
  const [peso_kg, setPeso_kg] = useState('');
  const [body_fat_porcentaje, setBody_fat_porcentaje] = useState('');
  const [altura_con_zapatos, setAltura_con_zapatos] = useState('');
  const [altura_sin_zapatos, setAltura_sin_zapatos] = useState('');
  const [entrega_vertical, setEntrega_vertical] = useState('');
  const [entrega_horizontal, setEntrega_horizontal] = useState('');

  const [comentarios_observaciones_medidas, setComentarios_observaciones_medidas] =
    useState('');
  const [escala_perfil_atletico, setEscala_perfil_atletico] = useState('');
  const [informe_medico, setInforme_medico] = useState('');

  const [ataque_asp_ind_puntos_fuertes, setAtaque_asp_ind_puntos_fuertes] =
    useState('');
  const [ataque_asp_ind_objetivos_mejora, setAtaque_asp_ind_objetivos_mejora] =
    useState('');
  const [
    ataque_asp_ind_observaciones_individuales,
    setAtaque_asp_ind_observaciones_individuales
  ] = useState('');

  const [ataque_asp_col_puntos_fuertes, setAtaque_asp_col_puntos_fuertes] =
    useState('');
  const [ataque_asp_col_objetivos_mejora, setAtaque_asp_col_objetivos_mejora] =
    useState('');
  const [
    ataque_asp_col_observaciones_colectivas,
    setAtaque_asp_col_observaciones_colectivas
  ] = useState('');

  const [defensa_asp_ind_puntos_fuertes, setDefensa_asp_ind_puntos_fuertes] =
    useState('');
  const [defensa_asp_ind_objetivos_mejora, setDefensa_asp_ind_objetivos_mejora] =
    useState('');
  const [
    defensa_asp_ind_observaciones_individuales,
    setDefensa_asp_ind_observaciones_individuales
  ] = useState('');

  const [defensa_asp_col_puntos_fuertes, setDefensa_asp_col_puntos_fuertes] =
    useState('');
  const [defensa_asp_col_objetivos_mejora, setDefensa_asp_col_objetivos_mejora] =
    useState('');
  const [
    defensa_asp_col_observaciones_colectivas,
    setDefensa_asp_col_observaciones_colectivas
  ] = useState('');

  const [info_audiovisual_observaciones, setInfo_audiovisual_observaciones] =
    useState('');

  const [asp_fisicos_puntos_fuertes, setAsp_fisicos_puntos_fuertes] = useState('');
  const [asp_fisicos_aspectos_potenciar, setAsp_fisicos_aspectos_potenciar] =
    useState('');
  const [asp_fisicos_desarrollo_motriz, setAsp_fisicos_desarrollo_motriz] =
    useState('');
  const [asp_fisicos_observaciones, setAsp_fisicos_observaciones] = useState('');

  const [asp_psicologicos_observaciones, setAsp_psicologicos_observaciones] =
    useState('');

  const [ambito_academico_observaciones, setAmbito_academico_observaciones] =
    useState('');

  const [intel_observaciones, setIntel_observaciones] = useState('');

  // ===========================
  // ESTADOS FICHA MÉDICA
  // ===========================
  const [medicalFuente, setMedicalFuente] = useState('');
  const [medicalLibelle, setMedicalLibelle] = useState('');
  const [medicalChirurgie, setMedicalChirurgie] = useState('');
  const [medicalRecuperation, setMedicalRecuperation] = useState('');
  const [medicalAfficheLogoBlessure, setMedicalAfficheLogoBlessure] = useState(false);

  // Manejo de navegación si hay cambios sin guardar
  useEffect(() => {
    const handleBeforeUnload = (event) => {
      if (isDirty) {
        event.preventDefault();
        event.returnValue = t('playerCardCreator.unsavedChanges');
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    const handlePopState = (event) => {
      if (isDirty) {
        const confirmLeave = window.confirm(t('playerCardCreator.unsavedChanges'));
        if (!confirmLeave) {
          window.history.pushState(null, '', window.location.pathname);
        }
      }
    };

    window.addEventListener('popstate', handlePopState);

    const originalPushState = window.history.pushState;
    const originalReplaceState = window.history.replaceState;

    const confirmNavigation = () => {
      if (!isDirty) return true;
      return window.confirm(t('playerCardCreator.unsavedChanges'));
    };

    window.history.pushState = function (...args) {
      if (confirmNavigation()) {
        return originalPushState.apply(this, args);
      }
      return null;
    };

    window.history.replaceState = function (...args) {
      if (confirmNavigation()) {
        return originalReplaceState.apply(this, args);
      }
      return null;
    };

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
      window.removeEventListener('popstate', handlePopState);
      window.history.pushState = originalPushState;
      window.history.replaceState = originalReplaceState;
    };
  }, [isDirty]);

  const markDirty = () => {
    setIsDirty(true);
  };

  const [searchParams] = useSearchParams();

  // Récupération éventuelle du playerId y cardType via la URL
  useEffect(() => {
    const playerId = searchParams.get('playerId');
    const preselectedType = searchParams.get('cardType');

    if (playerId) {
      const foundPlayer = players.find((p) => p.id === parseInt(playerId));
      if (foundPlayer) {
        setSelectedPlayer(foundPlayer);
        setShowPlayerSelection(false); // Minimiser la sélection une fois choisi
      }
    }

    if (preselectedType) {
      setCardType(preselectedType);
    }
  }, [searchParams, players]);

  // Carga de eventos
  useEffect(() => {
    const fetchEventos = async () => {
      try {
        const response = await api.get('/api/informe/eventos');
        setEventos(response.data);
      } catch (error) {
        console.error('Error fetching eventos:', error);
        setEventos([]);
      }
    };
    fetchEventos();
  }, []);

  const reloadEventos = async () => {
    try {
      const timestamp = new Date().getTime();
      const response = await api.get('/api/informe/eventos', {
        params: { t: timestamp }
      });
      setEventos(response.data);
    } catch (error) {
      console.error('Error reloading eventos:', error);
    }
  };

  // Carga inicial de jugadores y user
  useEffect(() => {
    const fetchPlayers = async () => {
      try {
        const response = await api.get('/api/players/select');
        setPlayers(response.data.players);
      } catch (error) {
        console.error('Error al obtener los jugador@s:', error);
      }
    };

    fetchPlayers();
    resetFecha();

    const storedUser = JSON.parse(localStorage.getItem('user'));
    if (storedUser && storedUser.id) {
      setUserId(storedUser.id);
    }
  }, []);

  // Carga de equipos
  useEffect(() => {
    const fetchTeams = async () => {
      try {
        const response = await api.get('/api/players/teams');
        setTeams(response.data.teams || []);
      } catch (error) {
        console.error('Error fetching teams:', error);
      }
    };
    fetchTeams();
  }, []);

  // Carga de equipos existentes desde fiches_suivi_informe
  useEffect(() => {
    const fetchExistingEquipos = async () => {
      try {
        const response = await api.get('/api/informe/equipos');
        setExistingEquipos(response.data || []);
      } catch (error) {
        console.error('Error fetching existing equipos:', error);
        setExistingEquipos([]);
      }
    };
    fetchExistingEquipos();
  }, []);

  useEffect(() => {
    if (!selectedPlayer) {
      setEquipo('');
    } else {
      setEquipo(selectedPlayer.team || '');
    }

    if (selectedPlayer && cardType === 'informe' && userId) {
      const fetchExistingVerdict = async () => {
        try {
          const response = await api.get('/api/informe/scout-verdict', {
            params: {
              user_id: userId,
              player_id: selectedPlayer.id
            }
          });
          if (response.data.exists && response.data.verdict) {
            setVerdict(response.data.verdict);
          } else {
            setVerdict('');
          }
        } catch (error) {
          console.error('Error fetching existing verdict:', error);
          setVerdict('');
        }
      };
      fetchExistingVerdict();
    }
  }, [selectedPlayer, cardType, userId]);

  // Pré-remplissage de "equipo" depuis le dernier informe du joueur (si non modifié par l'utilisateur)
  useEffect(() => {
    if (!selectedPlayer || cardType !== 'informe') return;

    let cancelled = false;
    const prefillEquipoFromLastInforme = async () => {
      try {
        const response = await api.get('/api/informe', {
          params: { playerId: selectedPlayer.id }
        });
        if (cancelled) return;
        const list = Array.isArray(response.data) ? response.data : [];
        const lastEquipo = list.find(i => i.equipo && i.equipo.trim())?.equipo;
        if (lastEquipo) setEquipo(lastEquipo);
      } catch (error) {
        console.error('Error fetching last informe equipo:', error);
      }
    };
    prefillEquipoFromLastInforme();

    return () => { cancelled = true; };
  }, [selectedPlayer, cardType]);

  // Pré-remplissage des mesures physiques depuis la dernière fiche technique du joueur
  useEffect(() => {
    if (!selectedPlayer || cardType !== 'techniques') return;

    const prefillFromLastTecnica = async () => {
      try {
        const response = await api.get('/api/technique', {
          params: { playerId: selectedPlayer.id }
        });
        const data = response.data;
        if (!Array.isArray(data) || data.length === 0) return;

        const last = data[0]; // trié par fecha DESC côté backend
        const toStr = (v) => (v === null || v === undefined ? '' : String(v));
        setPeso_kg(toStr(last.peso_kg));
        setBody_fat_porcentaje(toStr(last.body_fat_porcentaje));
        setAltura_con_zapatos(toStr(last.altura_con_zapatos));
        setAltura_sin_zapatos(toStr(last.altura_sin_zapatos));
        setEntrega_vertical(toStr(last.entrega_vertical));
        setEntrega_horizontal(toStr(last.entrega_horizontal));
      } catch (error) {
        console.error('Error prefilling tecnica measurements:', error);
      }
    };

    prefillFromLastTecnica();
  }, [selectedPlayer, cardType]);

  const resetFecha = () => {
    const today = new Date();
    const formattedDate = today.toISOString().split('T')[0];
    setFecha(formattedDate);
  };

  // === Función para resetear TODOS los campos ===
  const resetForm = () => {
    setSelectedPlayer(null);
    setCardType('');
    setShowPlayerSelection(true);
    resetFecha();
    setEvento('');
    setFuente('');
    setDetalles('');
    setEquipo('');
    setVisualizacion('');
    setTitre('');
    setVideoUrl('');
    setNivel('');
    setProjection('');
    setVerdict('');
    setMediaFile(null);
    setFitEstilo(null);
    setFitFisico(null);
    setFitActitud(null);
    setFitMejora(null);
    setFitContexto(null);
    setStatsUrl('');
    setDefensiveVersatility(null);

    setPeso_kg('');
    setBody_fat_porcentaje('');
    setAltura_con_zapatos('');
    setAltura_sin_zapatos('');
    setEntrega_vertical('');
    setEntrega_horizontal('');
    setComentarios_observaciones_medidas('');
    setEscala_perfil_atletico('');
    setInforme_medico('');
    setAtaque_asp_ind_puntos_fuertes('');
    setAtaque_asp_ind_objetivos_mejora('');
    setAtaque_asp_ind_observaciones_individuales('');
    setAtaque_asp_col_puntos_fuertes('');
    setAtaque_asp_col_objetivos_mejora('');
    setAtaque_asp_col_observaciones_colectivas('');
    setDefensa_asp_ind_puntos_fuertes('');
    setDefensa_asp_ind_objetivos_mejora('');
    setDefensa_asp_ind_observaciones_individuales('');
    setDefensa_asp_col_puntos_fuertes('');
    setDefensa_asp_col_objetivos_mejora('');
    setDefensa_asp_col_observaciones_colectivas('');
    setInfo_audiovisual_observaciones('');
    setAsp_fisicos_puntos_fuertes('');
    setAsp_fisicos_aspectos_potenciar('');
    setAsp_fisicos_desarrollo_motriz('');
    setAsp_fisicos_observaciones('');
    setAsp_psicologicos_observaciones('');
    setAmbito_academico_observaciones('');
    setIntel_observaciones('');
    setMedicalFuente('');
    setMedicalLibelle('');
    setMedicalChirurgie('');
    setMedicalRecuperation('');
    setMedicalAfficheLogoBlessure(false);

    setIsDirty(false);
  };

  const handleCardTypeChange = (e) => {
    setCardType(e.target.value);
    markDirty();
  };

  const transformDetalles = (text) => {
    return text.replace(/<p>/g, '').replace(/<\/p>/g, '<br />').trim();
  };

  // Fonction principale de guardado
  const handleCreateCard = async () => {
    if (isSubmitting) return;
    setIsSubmitting(true);

    if (!selectedPlayer || !cardType) {
      alert(t('playerCardCreator.selectPlayerAndType'));
      setIsSubmitting(false);
      return;
    }

    const formattedDetalles = transformDetalles(detalles);

    try {
      if (cardType === 'informe') {
        if (!fecha) {
          alert(t('playerCardCreator.informeForm.enterDate'));
          setIsSubmitting(false);
          return;
        }
        if (!evento) {
          alert(t('playerCardCreator.informeForm.enterEvent'));
          setIsSubmitting(false);
          return;
        }
        if (!visualizacion) {
          alert(t('playerCardCreator.informeForm.selectScoutingType'));
          setIsSubmitting(false);
          return;
        }
        if (!verdict) {
          alert(t('playerCardCreator.informeForm.selectVerdictRequired'));
          setIsSubmitting(false);
          return;
        }
        const detallesIsEmpty = !detalles || detalles.replace(/<[^>]*>/g, '').replace(/&nbsp;/g, '').trim().length === 0;
        if (detallesIsEmpty) {
          alert(t('playerCardCreator.informeForm.enterDetails'));
          setIsSubmitting(false);
          return;
        }
        
        const promises = [];

        // Utiliser FormData si un fichier média est présent
        let informePromise;
        if (mediaFile) {
          const formData = new FormData();
          formData.append('playerId', selectedPlayer.id);
          formData.append('fecha', fecha);
          formData.append('id_usuarios', userId);
          formData.append('evento', evento);
          formData.append('equipo', equipo);
          formData.append('detalles', formattedDetalles);
          formData.append('visu', visualizacion);
          formData.append('nivel', nivel || '');
          formData.append('projection', projection || '');
          if (fitEstilo !== null) formData.append('fit_estilo', fitEstilo ? '1' : '0');
          if (fitFisico !== null) formData.append('fit_fisico', fitFisico ? '1' : '0');
          if (fitActitud !== null) formData.append('fit_actitud', fitActitud ? '1' : '0');
          if (fitMejora !== null) formData.append('fit_mejora', fitMejora ? '1' : '0');
          if (fitContexto !== null) formData.append('fit_contexto', fitContexto ? '1' : '0');
          if (statsUrl) formData.append('stats_url', statsUrl);
          if (defensiveVersatility) formData.append('defensive_versatility', JSON.stringify(defensiveVersatility));
          formData.append('media', mediaFile);

          informePromise = api.post('/api/informe', formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          });
        } else {
          informePromise = api.post('/api/informe', {
            playerId: selectedPlayer.id,
            fecha,
            id_usuarios: userId,
            evento,
            equipo,
            detalles: formattedDetalles,
            visu: visualizacion,
            nivel: nivel || '',
            projection: projection || '',
            ...(fitEstilo !== null && { fit_estilo: fitEstilo ? 1 : 0 }),
            ...(fitFisico !== null && { fit_fisico: fitFisico ? 1 : 0 }),
            ...(fitActitud !== null && { fit_actitud: fitActitud ? 1 : 0 }),
            ...(fitMejora !== null && { fit_mejora: fitMejora ? 1 : 0 }),
            ...(fitContexto !== null && { fit_contexto: fitContexto ? 1 : 0 }),
            ...(statsUrl && { stats_url: statsUrl }),
            ...(defensiveVersatility && { defensive_versatility: defensiveVersatility })
          });
        }
        promises.push(informePromise);

        const verdictPromise = api.post('/api/informe/scout-verdict', {
          user_id: userId,
          player_id: selectedPlayer.id,
          verdict: verdict
        });
        promises.push(verdictPromise);

        await Promise.all(promises);
        
        if (!eventos.includes(evento)) {
          await reloadEventos();
        }
        
        alert(t('playerCardCreator.savedSuccess'));
        resetForm();
        return;
      } else if (cardType === 'intel') {
        if (!fuente) {
          alert(t('playerCardCreator.intelForm.enterSource'));
          setIsSubmitting(false);
          return;
        }
        const intelPromise = api.post('/api/intel', {
          playerId: selectedPlayer.id,
          fecha,
          id_usuarios: userId,
          fuente,
          detalles: formattedDetalles
        });
        await intelPromise;
      } else if (cardType === 'techniques') {
        const num = (val) => (val && val.trim() !== '' ? val.trim() : null);
        const txt = (val) =>
          val && val.trim() !== '' ? transformDetalles(val) : ' ';

        const techniquesPromise = api.post('/api/technique', {
          playerId: selectedPlayer.id,
          fecha,
          id_usuarios: userId,
          peso_kg: num(peso_kg),
          body_fat_porcentaje: num(body_fat_porcentaje),
          altura_con_zapatos: num(altura_con_zapatos),
          altura_sin_zapatos: num(altura_sin_zapatos),
          entrega_vertical: num(entrega_vertical),
          entrega_horizontal: num(entrega_horizontal),
          comentarios_observaciones_medidas: txt(comentarios_observaciones_medidas),
          escala_perfil_atletico: txt(escala_perfil_atletico),
          informe_medico: txt(informe_medico),
          ataque_asp_ind_puntos_fuertes: txt(ataque_asp_ind_puntos_fuertes),
          ataque_asp_ind_objetivos_mejora: txt(ataque_asp_ind_objetivos_mejora),
          ataque_asp_ind_observaciones_individuales: txt(
            ataque_asp_ind_observaciones_individuales
          ),
          ataque_asp_col_puntos_fuertes: txt(ataque_asp_col_puntos_fuertes),
          ataque_asp_col_objetivos_mejora: txt(ataque_asp_col_objetivos_mejora),
          ataque_asp_col_observaciones_colectivas: txt(
            ataque_asp_col_observaciones_colectivas
          ),
          defensa_asp_ind_puntos_fuertes: txt(defensa_asp_ind_puntos_fuertes),
          defensa_asp_ind_objetivos_mejora: txt(defensa_asp_ind_objetivos_mejora),
          defensa_asp_ind_observaciones_individuales: txt(
            defensa_asp_ind_observaciones_individuales
          ),
          defensa_asp_col_puntos_fuertes: txt(defensa_asp_col_puntos_fuertes),
          defensa_asp_col_objetivos_mejora: txt(defensa_asp_col_objetivos_mejora),
          defensa_asp_col_observaciones_colectivas: txt(
            defensa_asp_col_observaciones_colectivas
          ),
          info_audiovisual_observaciones: txt(info_audiovisual_observaciones),
          asp_fisicos_puntos_fuertes: txt(asp_fisicos_puntos_fuertes),
          asp_fisicos_aspectos_potenciar: txt(asp_fisicos_aspectos_potenciar),
          asp_fisicos_desarrollo_motriz: txt(asp_fisicos_desarrollo_motriz),
          asp_fisicos_observaciones: txt(asp_fisicos_observaciones),
          asp_psicologicos_observaciones: txt(asp_psicologicos_observaciones),
          ambito_academico_observaciones: txt(ambito_academico_observaciones),
          intel_observaciones: txt(intel_observaciones)
        });
        await techniquesPromise;
      } else if (cardType === 'video') {
        if (!titre || !videoUrl) {
          alert(t('playerCardCreator.mediaForm.enterTitleAndUrl'));
          setIsSubmitting(false);
          return;
        }
        const videoPromise = api.post('/api/videos', {
          playerId: selectedPlayer.id,
          fecha,
          id_usuarios: userId,
          titre,
          url: videoUrl,
          detalles: formattedDetalles
        });
        await videoPromise;
      } else if (cardType === 'medical') {
        if (!fecha) {
          alert(t('playerCardCreator.medicalForm.dateRequired'));
          setIsSubmitting(false);
          return;
        }
        if (
          selectedPlayer.type &&
          selectedPlayer.type.toLowerCase() === 'pro' &&
          !medicalFuente
        ) {
          alert(t('playerCardCreator.medicalForm.sourceRequired'));
          setIsSubmitting(false);
          return;
        }

        const medicalPromise = api.post('/api/medical', {
          date: fecha,
          idnuser: userId,
          id_player: selectedPlayer.id,
          fuente: medicalFuente,
          libelle: medicalLibelle,
          chirurgie: medicalChirurgie,
          recuperation: medicalRecuperation,
          affiche_logo_blessure: medicalAfficheLogoBlessure
        });
        await medicalPromise;
      }

      if (cardType !== 'medidas') {
        alert(t('playerCardCreator.savedSuccess'));
        resetForm();
      }
    } catch (error) {
      console.error('Error al guardar la ficha:', error);
      alert(t('playerCardCreator.saveError'));
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleCloseMedidas = () => {
    resetForm();
  };

  // Configuración de los tipos de fichas con iconos y colores
  const cardTypesConfig = [
    { value: 'informe', labelKey: 'cardTypes.informe', emoji: '📊', color: '#4ECDC4', icon: Assignment },
    { value: 'intel', labelKey: 'cardTypes.intel', emoji: '🔍', color: '#45B7D1', icon: Timeline },
    { value: 'techniques', labelKey: 'cardTypes.tecnica', emoji: '🏋️', color: '#FF6B6B', icon: Analytics },
    { value: 'video', labelKey: 'cardTypes.videos', emoji: '🎥', color: '#96CEB4', icon: Person },
    { value: 'medical', labelKey: 'cardTypes.medical', emoji: '🏥', color: '#FECA57', icon: Favorite },
    { value: 'medidas', labelKey: 'cardTypes.medidas', emoji: '📏', color: '#FF9FF3', icon: Analytics },
    { value: 'documents', labelKey: 'cardTypes.documents', emoji: '📎', color: '#A29BFE', icon: FolderOpen }
  ];

  // Styles compacts
  const containerStyle = {
    backgroundColor: '#f8f9fa',
    minHeight: '100vh',
    py: 1
  };

  const compactSectionStyle = {
    background: 'white',
    borderRadius: 2,
    border: '1px solid #e0e0e0',
    boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
    p: 2,
    mb: 2
  };

  const headerStyle = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    mb: 2,
    cursor: 'pointer'
  };

  return (
    <Box sx={containerStyle}>
      <Box sx={{ width: '100%', margin: 0, padding: 0 }}>
        <Box sx={{ p: 2 }}>
          {/* Header avec sélection de joueur compacte */}
        <Paper sx={compactSectionStyle}>
          <Box sx={headerStyle} onClick={() => setShowPlayerSelection(!showPlayerSelection)}>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <Person sx={{ mr: 1, color: 'primary.main' }} />
              <Typography variant="h6" fontWeight={600}>
                {selectedPlayer ? selectedPlayer.nom : t('playerCardCreator.selectPlayer')}
              </Typography>
              {selectedPlayer && (
                <Avatar
                  src={`${mediaUrl}/photos/${selectedPlayer.id}.png`}
                  alt={selectedPlayer.nom}
                  sx={{ width: 32, height: 32, ml: 2 }}
                />
              )}
            </Box>
            <IconButton size="small">
              {showPlayerSelection ? <ExpandLess /> : <ExpandMore />}
            </IconButton>
          </Box>

          <Collapse in={showPlayerSelection}>
            <FormControl fullWidth variant="outlined">
              <Autocomplete
                options={players}
                getOptionLabel={(player) => player.nom}
                value={selectedPlayer}
                onChange={(event, newValue) => {
                  setSelectedPlayer(newValue);
                  markDirty();
                  if (newValue) {
                    setShowPlayerSelection(false);
                  }
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={t('playerCardCreator.searchPlayer')}
                    variant="outlined"
                    size="small"
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        borderRadius: 2,
                        background: 'rgba(255,255,255,0.9)'
                      }
                    }}
                  />
                )}
                renderOption={(props, player) => (
                  <Box
                    component="li"
                    {...props}
                    sx={{ 
                      display: 'flex', 
                      alignItems: 'center',
                      p: 1.5,
                      borderRadius: 1,
                      mx: 0.5,
                      my: 0.25,
                      transition: 'all 0.2s ease',
                      '&:hover': {
                        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                        color: 'white',
                        transform: 'translateX(4px)',
                        boxShadow: '0 4px 12px rgba(102, 126, 234, 0.3)'
                      }
                    }}
                  >
                    <Avatar
                      src={`${mediaUrl}/photos/${player.id}.png`}
                      alt={player.nom}
                      sx={{ 
                        width: 36, 
                        height: 36, 
                        marginRight: 1.5,
                        border: '2px solid rgba(255,255,255,0.3)',
                        transition: 'all 0.2s ease'
                      }}
                    />
                    <Typography variant="body2" fontWeight={500}>
                      {player.nom}
                    </Typography>
                  </Box>
                )}
                ListboxComponent={ListboxComponent}
                size="small"
              />
            </FormControl>
          </Collapse>
        </Paper>

          {/* Sélection du type de fiche compacte */}
        <Paper sx={compactSectionStyle}>
          <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
            <Assignment sx={{ mr: 1, color: 'primary.main' }} />
            <Typography variant="h6" fontWeight={600}>
              {t('playerCardCreator.cardType')}
            </Typography>
          </Box>

          <Grid container spacing={1}>
            {cardTypesConfig.map((type) => (
              <Grid item xs={6} sm={4} md key={type.value}>
                <Card
                  onClick={() => {
                    setCardType(type.value);
                    markDirty();
                  }}
                  sx={{
                    cursor: 'pointer',
                    background: cardType === type.value 
                      ? `linear-gradient(135deg, ${type.color}22 0%, ${type.color}44 100%)`
                      : 'rgba(255,255,255,0.9)',
                    border: cardType === type.value 
                      ? `2px solid ${type.color}` 
                      : '1px solid #e0e0e0',
                    borderRadius: 2,
                    transition: 'all 0.2s ease',
                    transform: cardType === type.value ? 'scale(1.02)' : 'scale(1)',
                    minHeight: 70,
                    '&:hover': {
                      transform: 'scale(1.05)',
                      boxShadow: `0 4px 12px ${alpha(type.color, 0.2)}`
                    }
                  }}
                >
                  <CardContent sx={{ textAlign: 'center', p: 1 }}>
                    <Box
                      sx={{
                        width: 30,
                        height: 30,
                        borderRadius: '50%',
                        background: `linear-gradient(135deg, ${type.color} 0%, ${type.color}88 100%)`,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        mx: 'auto',
                        mb: 0.5
                      }}
                    >
                      <type.icon sx={{ color: 'white', fontSize: '1rem' }} />
                    </Box>
                    <Typography
                      variant="caption"
                      fontWeight={600}
                      sx={{
                        color: cardType === type.value ? type.color : 'text.primary',
                        fontSize: '0.7rem'
                      }}
                    >
                      {type.emoji} {t(`playerCardCreator.${type.labelKey}`)}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Paper>

          {/* Formularios específicos */}
        {cardType && (
          <Box>
            {cardType === 'informe' && (
              <CreateInforme
                fecha={fecha}
                setFecha={setFecha}
                evento={evento}
                setEvento={setEvento}
                equipo={equipo}
                setEquipo={setEquipo}
                detalles={detalles}
                setDetalles={setDetalles}
                visualizacion={visualizacion}
                setVisualizacion={setVisualizacion}
                eventos={eventos}
                teams={teams}
                existingEquipos={existingEquipos}
                markDirty={markDirty}
                isSubmitting={isSubmitting}
                handleCreateCard={handleCreateCard}
                backendUrl={backendUrl}
                nivel={nivel}
                setNivel={setNivel}
                projection={projection}
                setProjection={setProjection}
                verdict={verdict}
                setVerdict={setVerdict}
                mediaFile={mediaFile}
                setMediaFile={setMediaFile}
                fitEstilo={fitEstilo}
                setFitEstilo={setFitEstilo}
                fitFisico={fitFisico}
                setFitFisico={setFitFisico}
                fitActitud={fitActitud}
                setFitActitud={setFitActitud}
                fitMejora={fitMejora}
                setFitMejora={setFitMejora}
                fitContexto={fitContexto}
                setFitContexto={setFitContexto}
                statsUrl={statsUrl}
                setStatsUrl={setStatsUrl}
                defensiveVersatility={defensiveVersatility}
                setDefensiveVersatility={setDefensiveVersatility}
              />
            )}

            {cardType === 'intel' && (
              <CreateIntel
                fecha={fecha}
                setFecha={setFecha}
                fuente={fuente}
                setFuente={setFuente}
                detalles={detalles}
                setDetalles={setDetalles}
                markDirty={markDirty}
                isSubmitting={isSubmitting}
                handleCreateCard={handleCreateCard}
                backendUrl={backendUrl}
              />
            )}

            {cardType === 'video' && (
              <CreateMedia
                fecha={fecha}
                setFecha={setFecha}
                titre={titre}
                setTitre={setTitre}
                videoUrl={videoUrl}
                setVideoUrl={setVideoUrl}
                detalles={detalles}
                setDetalles={setDetalles}
                markDirty={markDirty}
                isSubmitting={isSubmitting}
                handleCreateCard={handleCreateCard}
                backendUrl={backendUrl}
              />
            )}

            {cardType === 'techniques' && (
              <CreateTecnica
                fecha={fecha}
                setFecha={setFecha}
                peso_kg={peso_kg}
                setPeso_kg={setPeso_kg}
                body_fat_porcentaje={body_fat_porcentaje}
                setBody_fat_porcentaje={setBody_fat_porcentaje}
                altura_con_zapatos={altura_con_zapatos}
                setAltura_con_zapatos={setAltura_con_zapatos}
                altura_sin_zapatos={altura_sin_zapatos}
                setAltura_sin_zapatos={setAltura_sin_zapatos}
                entrega_vertical={entrega_vertical}
                setEntrega_vertical={setEntrega_vertical}
                entrega_horizontal={entrega_horizontal}
                setEntrega_horizontal={setEntrega_horizontal}
                comentarios_observaciones_medidas={comentarios_observaciones_medidas}
                setComentarios_observaciones_medidas={setComentarios_observaciones_medidas}
                escala_perfil_atletico={escala_perfil_atletico}
                setEscala_perfil_atletico={setEscala_perfil_atletico}
                informe_medico={informe_medico}
                setInforme_medico={setInforme_medico}
                ataque_asp_ind_puntos_fuertes={ataque_asp_ind_puntos_fuertes}
                setAtaque_asp_ind_puntos_fuertes={setAtaque_asp_ind_puntos_fuertes}
                ataque_asp_ind_objetivos_mejora={ataque_asp_ind_objetivos_mejora}
                setAtaque_asp_ind_objetivos_mejora={setAtaque_asp_ind_objetivos_mejora}
                ataque_asp_ind_observaciones_individuales={ataque_asp_ind_observaciones_individuales}
                setAtaque_asp_ind_observaciones_individuales={setAtaque_asp_ind_observaciones_individuales}
                ataque_asp_col_puntos_fuertes={ataque_asp_col_puntos_fuertes}
                setAtaque_asp_col_puntos_fuertes={setAtaque_asp_col_puntos_fuertes}
                ataque_asp_col_objetivos_mejora={ataque_asp_col_objetivos_mejora}
                setAtaque_asp_col_objetivos_mejora={setAtaque_asp_col_objetivos_mejora}
                ataque_asp_col_observaciones_colectivas={ataque_asp_col_observaciones_colectivas}
                setAtaque_asp_col_observaciones_colectivas={setAtaque_asp_col_observaciones_colectivas}
                defensa_asp_ind_puntos_fuertes={defensa_asp_ind_puntos_fuertes}
                setDefensa_asp_ind_puntos_fuertes={setDefensa_asp_ind_puntos_fuertes}
                defensa_asp_ind_objetivos_mejora={defensa_asp_ind_objetivos_mejora}
                setDefensa_asp_ind_objetivos_mejora={setDefensa_asp_ind_objetivos_mejora}
                defensa_asp_ind_observaciones_individuales={defensa_asp_ind_observaciones_individuales}
                setDefensa_asp_ind_observaciones_individuales={setDefensa_asp_ind_observaciones_individuales}
                defensa_asp_col_puntos_fuertes={defensa_asp_col_puntos_fuertes}
                setDefensa_asp_col_puntos_fuertes={setDefensa_asp_col_puntos_fuertes}
                defensa_asp_col_objetivos_mejora={defensa_asp_col_objetivos_mejora}
                setDefensa_asp_col_objetivos_mejora={setDefensa_asp_col_objetivos_mejora}
                defensa_asp_col_observaciones_colectivas={defensa_asp_col_observaciones_colectivas}
                setDefensa_asp_col_observaciones_colectivas={setDefensa_asp_col_observaciones_colectivas}
                info_audiovisual_observaciones={info_audiovisual_observaciones}
                setInfo_audiovisual_observaciones={setInfo_audiovisual_observaciones}
                asp_fisicos_puntos_fuertes={asp_fisicos_puntos_fuertes}
                setAsp_fisicos_puntos_fuertes={setAsp_fisicos_puntos_fuertes}
                asp_fisicos_aspectos_potenciar={asp_fisicos_aspectos_potenciar}
                setAsp_fisicos_aspectos_potenciar={setAsp_fisicos_aspectos_potenciar}
                asp_fisicos_desarrollo_motriz={asp_fisicos_desarrollo_motriz}
                setAsp_fisicos_desarrollo_motriz={setAsp_fisicos_desarrollo_motriz}
                asp_fisicos_observaciones={asp_fisicos_observaciones}
                setAsp_fisicos_observaciones={setAsp_fisicos_observaciones}
                asp_psicologicos_observaciones={asp_psicologicos_observaciones}
                setAsp_psicologicos_observaciones={setAsp_psicologicos_observaciones}
                ambito_academico_observaciones={ambito_academico_observaciones}
                setAmbito_academico_observaciones={setAmbito_academico_observaciones}
                intel_observaciones={intel_observaciones}
                setIntel_observaciones={setIntel_observaciones}
                markDirty={markDirty}
                isSubmitting={isSubmitting}
                handleCreateCard={handleCreateCard}
                backendUrl={backendUrl}
              />
            )}

            {cardType === 'medical' && (
              <CreateMedical
                fecha={fecha}
                setFecha={setFecha}
                medicalFuente={medicalFuente}
                setMedicalFuente={setMedicalFuente}
                medicalLibelle={medicalLibelle}
                setMedicalLibelle={setMedicalLibelle}
                medicalChirurgie={medicalChirurgie}
                setMedicalChirurgie={setMedicalChirurgie}
                medicalRecuperation={medicalRecuperation}
                setMedicalRecuperation={setMedicalRecuperation}
                medicalAfficheLogoBlessure={medicalAfficheLogoBlessure}
                setMedicalAfficheLogoBlessure={setMedicalAfficheLogoBlessure}
                markDirty={markDirty}
                isSubmitting={isSubmitting}
                handleCreateCard={handleCreateCard}
                backendUrl={backendUrl}
                playerType={selectedPlayer?.type}
              />
            )}

            {cardType === 'medidas' && (
              <CreateMedidas
                playerId={selectedPlayer?.id}
                backendUrl={backendUrl}
                section={section}
                markDirty={markDirty}
                isSubmitting={isSubmitting}
                onClose={handleCloseMedidas}
              />
            )}

            {cardType === 'documents' && (
              <CreateDocuments
                playerId={selectedPlayer?.id}
                markDirty={markDirty}
                isSubmitting={isSubmitting}
                setIsSubmitting={setIsSubmitting}
                onSuccess={resetForm}
              />
            )}
          </Box>
        )}

          {/* Boutons d'action compacts */}
        {(selectedPlayer || cardType) && (
          <Box sx={{
            position: 'fixed',
            bottom: 16,
            right: 16,
            display: 'flex',
            gap: 1,
            zIndex: 1000
          }}>
            <Tooltip title={t('playerCardCreator.clearForm')}>
              <IconButton
                onClick={resetForm}
                sx={{
                  background: 'linear-gradient(135deg, #ff6b6b 0%, #ee5a24 100%)',
                  color: 'white',
                  boxShadow: '0 4px 12px rgba(255, 107, 107, 0.3)',
                  '&:hover': {
                    background: 'linear-gradient(135deg, #ee5a24 0%, #ff6b6b 100%)',
                    transform: 'scale(1.1)'
                  }
                }}
              >
                <Refresh />
              </IconButton>
            </Tooltip>
          </Box>
        )}
        </Box>
      </Box>
    </Box>
  );
};

export default PlayerCardCreator; 